/**
 * Donations are taken offsite. `/#donate` links (the main menu, older links
 * shared elsewhere) still work: the homepage sends them on to this form.
 */
export const DONATE_URL =
  'https://secure.lglforms.com/form_engine/s/fOrzrx_W51sfuYJLWceL2g';
